// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__9q6xW","titl":"item_titl__2tgys","sub-title":"item_sub-title__1gO3n"};